import React from 'react';
import styled from 'styled-components';

import Art404 from './svg/art_404.svg';

const View = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: auto;
  padding: 2rem;
  max-width: 1200px;
  height: 100%;
`;

export default () => (
  <View>
    <img src={Art404} alt="art pagina nao encontrada" />
  </View>
);
